import React from "react";
import {Cascader, Form, Input, InputNumber, Radio, Switch} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHSelect from "../../common/NHSelect";


class EditForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const {form,initFormData} = this.props;
        return (
            <div>
                <Form layout="horizontal">
                <NHFormItem id={'pkid'} form={form} 
                        initialValue={initFormData.PKID}>
                <InputNumber style={{display:'none'}} />
                </NHFormItem>
                <NHFormItem id={'sfxmid'} label={"收费项目"} required={true} form={form}
                        initialValue={initFormData.SFXMID}>
                        <NHSelect sign={"zhxg_yxxt_sfxm"} />
                    </NHFormItem>
                    <NHFormItem id={'pxh'} label={'排序号'} hasFeedback={true} form={form} required={true}
                                initialValue={initFormData.PXH ? initFormData.PXH : 1}>
                        <InputNumber min={1} max={999999}/>
                    </NHFormItem>
                </Form>
            </div>
        );
    }
}

const DkgzEditForm = Form.create()(EditForm);

export default DkgzEditForm;



// WEBPACK FOOTER //
// ./components/swbl/ahgsLstd/DkgzEditForm.js